import React, { Component } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Avatar, Button, CssBaseline, TextField, Grid, Typography, CircularProgress, Container } from '@mui/material';
import { QueuePlayNext, DeleteForever } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import Api from '../../services/api';
import CustomizedSnackbars from '../../components/material-snackbars';
import Dropzone from 'react-dropzone';
import HeaderMenu from '../../components/header-menu';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';import SimpleSelect from '../../components/select/simple';
import SimpleCheckBox from '../../components/checkbox/check';
import SimpleDatePicker from '../../components/date-pickers/inline';
import Footer from '../../components/footer';
import { browserHistory } from '../../helpers/history';
import Title from '../../components/title-name';
import * as Service from '../../services/organizationcalendar.service';
import * as componentActions from '../../redux/actions/organizationcalendars';
import { FormattedMessage,injectIntl } from 'react-intl';

class OrganizationCalendarEdit extends Component {

  constructor(props) {
    super(props);
    // console.log(props);
    const { userSession,organizationcalendars,  organizations} = this.props;
   
    this.fromProps = false
    if(this.props && this.props.location && this.props.location.state && this.props.location.state.from && this.props.location.state.from.length > 0)
      this.fromProps = true

    this.globalAdm = false;
    this.isClient = true;
    if(userSession.user.userrole == null){
      Api.logoff();
    }

    if(!organizationcalendars || (organizationcalendars && !organizationcalendars.organizationcalendar)) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/calleds`
    }

    userSession.user.userrole.map((item, key) => {
        if(item.role.roletype !=3){
            this.isClient = false;
        }
        if(item.role.roletype ==0){
          this.globalAdm =true;
        }
    });

    //console.log(moment(organizationcalendars.organizationcalendar.starttime).format('YYYY/MM/DD HH:mm:ss'));

    this.initialState = {
      UpdatedUser: userSession.user.id,
      id: organizationcalendars.organizationcalendar.id,
      OrganizationId:  organizationcalendars.organizationcalendar.organizationid,
      OrganizationText: organizationcalendars.organizationcalendar.OrganizationText,
      observation : organizationcalendars.organizationcalendar.observation == null ? '' : organizationcalendars.organizationcalendar.observation , 
      name : organizationcalendars.organizationcalendar.name == null ? '' : organizationcalendars.organizationcalendar.name , 
      eventdate : organizationcalendars.organizationcalendar.eventdate, 
      active : organizationcalendars.organizationcalendar.active, 
      recurrenteveryear : organizationcalendars.organizationcalendar.recurrenteveryear, 
      starttime : moment(organizationcalendars.organizationcalendar.starttime).format('HH:mm'),
      endtime : moment(organizationcalendars.organizationcalendar.endtime).format('HH:mm'),
      saveToAllOrganizationsInGroup: false,
    };         

    this.state = {
      organizationcalendar: this.initialState,
      organizations: organizations,
      files: [],
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      OrganizationList: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.changeValues = this.changeValues.bind(this);
  }

  componentWillReceiveProps(nextProps){
    const intl = this.props.intl;
                        if(nextProps.location.state === "reload"){
                            this.componentDidMount();
                        }
                    }    

     componentDidMount() {
       if(this.props.location && this.props.location.state.internal === true){
        this.getOrganizationsById(this.state.organizations.organization.id);
       }
       else{
        this.getOrganizations();
       }
     };
     async getOrganizations(){
          this.setState({ loading: true });
          var result = await Service.getOrganizations();
            if (result.success) {
              this.setState({ loading: false, OrganizationList: result.data });
                            
            } else {
              this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: result.response && result.response.data && result.response.data.errors &&  result.response.data.errors[0] ? result.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
              });
              Api.kickoff(result);  
            }
  };
  async getOrganizationsById(id){
    this.setState({ loading: true });
    var result = await Service.getOrganizationsByIdLight(id);
      if (result.success) {
        this.setState({ loading: false, OrganizationList: [result.data] });
                      
      } else {
        this.setState({
          loading: false, openNotification: true, notificationVariant: 'error',
          notificationMessage: result.response && result.response.data && result.response.data.errors &&  result.response.data.errors[0] ? result.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
        });
        Api.kickoff(result);  
      }
};
  handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    this.setState(prevState => ({
      organizationcalendar: {
        ...prevState.organizationcalendar,
        [name]: value
      }
    }));
  };

  handleSubmit = async e => {
    const intl = this.props.intl;
    e.preventDefault();

    if (this.state.organizationcalendar.OrganizationId == null || this.state.organizationcalendar.OrganizationId === 0) {
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: 'error',
        notificationMessage: intl.formatMessage({id:"organization.calendar.registration.missing.organization.field"}),
      });
      return false
    }

    this.setState({ loading: true });

    let data = new FormData();


      if (this.isClient) {
        this.setState(prevState => ({
          organizationcalendar: {
            ...prevState.organizationcalendar,
          }
        }));
      } else {
        this.setState(prevState => ({
          organizationcalendar: {
            ...prevState.organizationcalendar,
          }
        }));
      }


      for (let key in this.state.organizationcalendar) {
        if (key.toString().toLowerCase().indexOf('_date') > -1 || key.toString().toLowerCase().indexOf('date_') > -1 || key.toString().toLowerCase().indexOf('eventdate') > -1) {
          data.append(key, moment(this.state.organizationcalendar[key]).format('YYYY/MM/DD HH:mm:ss'));
        } else if(key.toString().toLowerCase().indexOf('starttime') > -1 || key.toString().toLowerCase().indexOf('endtime') > -1){
          data.append(key, "0001/01/01 "+this.state.organizationcalendar[key]+":00");
        }else {
          data.append(key, this.state.organizationcalendar[key]);
        }
      }

      this.state.files.forEach(file => data.append('filesUpload', file));
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
        Api.put('/organizationcalendars', data, config)

        .then(result => {
          if (result.data.success) {
            const intl = this.props.intl;
        const formattedList = result.data.data;
        formattedList.OrganizationId=  formattedList.organization ? formattedList.organization.id : 0;
        formattedList.OrganizationText=  formattedList.organization ? formattedList.organization.name : '';

            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'success',
              notificationMessage: intl.formatMessage({id:"edit.success"}),
              files: []
            });
        this.props.addCurrentOrganization(formattedList, this.state.organizations.organization);
        this.componentDidMount();
 
          }
          else{
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage:  result.data.errors && result.data.errors[0] ? result.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
            });

          }
        })
        .catch(err => {
          if(err.response && err.response.data && err.response.data.errors){
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})
            });
          }
          else{
            this.setState({
              loading: false,
              openNotification: true,
              notificationVariant: 'error',
              notificationMessage: err.response.data.errors ? err.response.data.errors[0] : this.props.intl.formatMessage({id:"process.error"})+err.response.data
            });
          }
        });
  };

  closeNotification() {
    this.setState({ openNotification: false });
  }

  changeValues(stateName, value, text = '') {
    this.setState({ loading: true });

    this.setState(prevState => ({
      organizationcalendar: {
        ...prevState.organizationcalendar,
        [stateName]: value
      }
    }));
        if(stateName === 'OrganizationId'){
          this.setState(prevState => ({
            organizationcalendar: {
              ...prevState.organizationcalendar,
              ['OrganizationText']: text,
            }
          }));
        }
 
    this.setState({ loading: false });

  };

  removeItem(file) {
    let array = [...this.state.files];
    let index = array.indexOf(file)
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ files: array });
    }
  }

    render() {
    const { classes, headerMenu, actionsHeaderMenu, organizationcalendars } = this.props;
    const { organizationcalendar } = this.state;
    const intl = this.props.intl;

    if(Api == null) {
      var l = this.props.match.params.lang;
      document.location.href=`/${l}/unavailable`
    }

     return (
      <div className={classes.root}>
        <HeaderMenu />
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: headerMenu.open,
          }, classes.actionsContent, {
            [classes.actionscontentShift]: actionsHeaderMenu.open,
          })}
        >
          <div className={classes.drawerHeader} />

          <Container component='main' maxWidth='md'>
            <CssBaseline />
            <div className={classes.paper} style={{ marginTop: 0 }}>
              <Grid container spacing={6}>
                <Grid item xs={12} sm={4}>
                    <Button variant='outlined' color='primary' onClick={() => {
                    this.fromProps ? this.props.history.push(`/${this.props.match.params.lang}/organization-edit`, { organizations: this.props.organizations, propTab: 3 }) : browserHistory.goBack()}}>{this.props.intl.formatMessage({id:"back"})}</Button>
                </Grid>
                <Grid item xs={12} sm={8} />
              </Grid>
              <Avatar className={classes.avatar}>
                <QueuePlayNext />
              </Avatar>
              <Typography component='h1' variant='h5'>
              {<FormattedMessage id="edit.item" />}
              <Title />
              </Typography>
              <form name='myForm' className={classes.form} onSubmit={this.handleSubmit} encType='multipart/form-data'>
                    <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <SimpleSelect label={intl.formatMessage({id:"organization"})} name='organizationid'  options={this.state.OrganizationList} stateName='OrganizationId' changeSelect={this.changeValues} selected={organizationcalendar.OrganizationId} />
                    </Grid>
                    <Grid item xs={12} sm={4} >
                      <SimpleDatePicker label='Data:' name='eventdate' stateName='eventdate' changeDate={this.changeValues} currentDate={organizationcalendar.eventdate} required />
                    </Grid>

                    <Grid item xs={12} sm={4} >
                      <TextField
                          id="time"
                          label={this.props.intl.formatMessage({id:"start.time"})}
                          type="time"
                          defaultValue={this.state.organizationcalendar.starttime}
                          className={classes.textField}
                          onChange={this.handleInputChange}
                          name='starttime'
                          required
                        />
                    </Grid>


                    <Grid item xs={12} sm={4}>
                      <TextField
                          id="time"
                          label={this.props.intl.formatMessage({id:"end.time"})}
                          type="time"
                          defaultValue={this.state.organizationcalendar.endtime}
                          className={classes.textField}
                          onChange={this.handleInputChange}
                          name='endtime'
                          required
                        />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField inputProps={{ maxLength: 255 }} fullWidth label={intl.formatMessage({id:"name"})} autoComplete='fname' variant='outlined' name='name' onChange={this.handleInputChange} value={organizationcalendar.name} required />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField fullWidth label={this.props.intl.formatMessage({id:"observation"})+':'} multiline rows={6} autoComplete='fname' variant='outlined' name='observation' onChange={this.handleInputChange} value={organizationcalendar.observation}  />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <SimpleCheckBox label={this.props.intl.formatMessage({id:"calendar.holiday.happen.every.year"})} name='recurrenteveryear' stateName='recurrenteveryear' changeSelect={this.changeValues} selected={organizationcalendar.recurrenteveryear} />
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <SimpleCheckBox label='Ativo' name='active' stateName='active' changeSelect={this.changeValues} selected={organizationcalendar.active} />
                    </Grid>
                  <Grid item xs={11} sm={11}>
                    <SimpleCheckBox
                    label={intl.formatMessage({id:"apply.changes.to.all.organizations.in.group"})}
                    name='saveToAllOrganizationsInGroup'
                    stateName='saveToAllOrganizationsInGroup' 
                    changeSelect={this.changeValues}
                    selected={organizationcalendar.saveToAllOrganizationsInGroup} />
                  </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ marginTop: 15, display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
                    <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                  <Grid item xs={12} sm={4}    >
                    <Button 
                      type='submit'
                      fullWidth
                      variant='contained'
                      color='primary'
                      className={classes.submit}
                    >
                      {<FormattedMessage id="save" />}
                    </Button>
                  </Grid>
                </Grid>
                </Grid>
                </Grid>
              </form>
            </div>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color='secondary' />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />                    
     </div>
    );
  }
}
OrganizationCalendarEdit.propTypes = {
                    classes: PropTypes.object.isRequired
                };
                const mapStateToProps = state => ({
                  actionsHeaderMenu: state.actionsHeaderMenu,
                    headerMenu: state.headerMenu,
                    userSession: state.userSession,
                    organizations: state.organizations,
                    organizationcalendars: state.organizationcalendars,
                    org: state.organization.organization
                });
                const mapDispatchToProps = dispatch =>
                    bindActionCreators(componentActions, dispatch);

            export default injectIntl(connect(mapStateToProps,mapDispatchToProps)(withStyles(Styles)(OrganizationCalendarEdit)));
